import React, { useState } from "react";
import { Drawer, Button } from "antd";
import { MenuOutlined } from "@ant-design/icons";
import "./NavBar.css";
import logo from "./../../../assets/logo.png";
import { MenuLocal } from "../../Header";
import { useLocation } from "react-router-dom";
import { Header } from "antd/lib/layout/layout";

export const NavBar = () => {
  const location = useLocation();
  const [visible, setVisible] = useState(false);
  return (
    <Header className="navbar">
      <Drawer
        title={
          <img
            src={logo}
            className="logo"
            alt="logo"
            style={{ marginLeft: 20, marginBottom: 5 }}
          />
        }
        placement="left"
        onClick={() => setVisible(false)}
        onClose={() => setVisible(false)}
        visible={visible}
      >
        {/* {menu} */}
        <MenuLocal location={location} />
      </Drawer>
      <a href="/">
        <img src={logo} className="logo" alt="logo" />
      </a>

      <Button
        className="menu"
        // type="primary"
        size="large"
        style={{
          backgroundColor: "transparent",
          border: "none",
          color: "#001529",
          borderRadius: 4,
          width: 40,
          height: 37,
        }}
        icon={<MenuOutlined style={{ fontSize: 30 }} />}
        onClick={() => setVisible(true)}
      />
    </Header>
  );
};
